const SERVER_API = 'api/v1/';

class LoginService {
    constructor(config, $http, $state, $filter, $log, $localStorage, storageService, principalService, authorizationService, utilsService, logoutService, crudService) {
        this.serverUrl = storageService.getManagerHostname();
        this.clientId = config.clientId;
        this.oAuthPermissionScopes = config.oAuthPermissionScopes;
        this._$http = $http;
        this._$state = $state;
        this._$filter = $filter;
        this.$log = $log;
        this.$localStorage = $localStorage;
        this.storageService = storageService;
        this.principalService = principalService;
        this.authorizationService = authorizationService;
        this.utilsService = utilsService;
        this.logoutService = logoutService;
        this.crudService = crudService
    }

    getClientId() {
        return this.clientId;
    }

    getServerUrl() {
        return this.serverUrl;
    }

    getOAuthPermissionScopes() {
        return this.oAuthPermissionScopes;
    }

    getAccessToken(userEmail) {
        const dataBody = {
            userEmail: userEmail
        }
        return this.crudService.post(`oauth/accessToken`, dataBody, null, true, null, true)
            .then((res) => {
                return res.data.entities;
            });
    }

    getProxRegAccessToken(proxyUrl, userEmail) {
        const dataBody = {
            userEmail: userEmail
        }
        return this.crudService.post(proxyUrl + SERVER_API + `oauth/accessToken`, dataBody, null, true, null, true, true)
            .then((res) => {
                return res.data.entities;
            });
    }

    getAccessTokenPerManager(userEmail, managerUrl) {
        const dataBody = {
            userEmail: userEmail
        }
        return this.crudService.post(managerUrl + SERVER_API + `oauth/accessToken`, dataBody, null, true, null, true, true)
            .then((res) => {
                return res.data.entities;
            });
    }

    login(person, managerUrl, subscription) {
        const id = person;
        const username = person;

        this.storageService.setUserUuid(id);
        // this.storageService.setUserType(type);

        if (angular.isDefined(this.storageService.getToken()) && this.storageService.getToken() !== '') {
            this.storageService.setUsername(username);
        }

        this.crudService.put(managerUrl + SERVER_API + `subscriptions/${subscription.uuid}/login`, null, null, null, true, true, true);
    }

}

LoginService.$inject = ['config', '$http', '$state', '$filter', '$log', '$localStorage', 'storageService', 'principalService', 'authorizationService', 'utilsService', 'logoutService', 'crudService'];

module.exports = LoginService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/login.service.js